<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clip-rule="evenodd"
      d="M17.25 19.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0ZM3.75 19.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.25 19.5h1.5a1.5 1.5 0 0 0 1.5-1.5v-3c0-.488-.152-.963-.436-1.36L19.5 9h-5.25v10.5M23.25 15h-9M14.25 19.5V12H.75v6a1.5 1.5 0 0 0 1.5 1.5h1.5M17.25 19.5H6.75"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      clip-rule="evenodd"
      d="M23.25 6a3 3 0 0 1-3 3h-6v3H.75V6a3 3 0 0 1 3-3h16.5a3 3 0 0 1 3 3Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.25 6h-1.5M12.75 6h-9"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
